import styles from './Communication.module.scss';

import { Theme, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { LabeledInput } from '../../../../../../../../locked-inputs';
import { ControlWrapper } from '../../../../../../../components/control-wrapper';
import { ContactMaskFormValue } from '../../../../../types';

import { Email } from './Email';

export const Communication: React.FC = () => {
  const { t } = useTranslation();

  const { register } = useFormContextPlus<ContactMaskFormValue>();

  const mobile = useMediaQuery<Theme>('(max-width:960px)');

  return (
    <Collapse defaultOpen={!mobile} title={t('MASK.COMMUNICATION')}>
      <ControlWrapper className={styles.mobileVert}>
        <Email />
        <LabeledInput
          label={t('INPUTS.PHONE_AND_EXTENSION_NUMBERS')}
          {...register('phoneNumber')}
        />
        <LabeledInput
          label={t('INPUTS.MOBILE')}
          {...register('mobileNumber')}
        />
      </ControlWrapper>
      <ControlWrapper className={styles.mobileVert}>
        <LabeledInput label={t('INPUTS.FAX')} {...register('faxNumber')} />
        <LabeledInput
          label={t('INPUTS.ADDITIONAL')}
          {...register('phoneNumber2')}
        />
        <LabeledInput
          label={t('INPUTS.ADDITIONAL')}
          {...register('phoneNumber3')}
        />
      </ControlWrapper>
    </Collapse>
  );
};
